import { useMemo } from 'react';
import { useKeyboardIsShowing } from '../../../../theme/keyboard.hook';

interface UseWidgetClassesProps {
  includeClasses?: string[];
  isNested?: boolean;
  isRippleUtilized?: boolean;
  isPaywalled?: boolean;
  /**
   * Whether to use transparent background. Defaults to true.
   */
  transparentBackground?: boolean;
}

export const useWidgetClasses = (props: UseWidgetClassesProps) => {
  const {
    includeClasses = [],
    isNested,
    isRippleUtilized,
    isPaywalled,
    transparentBackground = true,
  } = props;

  const isKeyboardShowing = useKeyboardIsShowing();

  const classes = useMemo(() => {
    const classList: string[] = ['widget'];

    if (transparentBackground !== false) {
      classList.push('transparent-background');
    }

    // For widgets that utilize the ripple effect
    if (isRippleUtilized && !isKeyboardShowing) {
      classList.push('ion-activatable');
    }

    if (isNested) {
      classList.push('nested-widget');
    }

    if (isPaywalled) {
      classList.push('paywalled-widget');
    }

    if (includeClasses.length > 0) {
      classList.push(...includeClasses);
    }

    return classList.join(' ');
  }, [
    includeClasses,
    isKeyboardShowing,
    isNested,
    isRippleUtilized,
    isPaywalled,
    transparentBackground,
  ]);

  return classes;
};
